var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data.length > 0
    ? _c(
        "v-container",
        { staticClass: "pa-0" },
        _vm._l(_vm.data, function(item, index) {
          return _c(
            "v-card",
            {
              key: item.ext ? "ext" : index,
              staticClass: "card default-banner akciova-ponuka",
              class: {
                "mb-15px": index < _vm.data.length - 1,
                "no-click-pointer": item.ext
              },
              on: {
                click: function($event) {
                  !item.ext && _vm.select(item)
                }
              }
            },
            [
              [
                !_vm.isMobile
                  ? _c("v-img", {
                      staticClass: "banner-image",
                      attrs: {
                        src: item.ext
                          ? item.src
                          : _vm.$router.options.base +
                            "upload/img_dashboard_banner/" +
                            (_vm.$vuetify.theme.dark
                              ? item.pozadie_obrazok_tmavy
                              : item.pozadie_obrazok_svetly)
                      }
                    })
                  : _c("v-img", {
                      staticClass: "image-responsive",
                      staticStyle: { widows: "100%" },
                      attrs: {
                        src: item.ext
                          ? item.src
                          : _vm.$router.options.base +
                            "upload/img_dashboard_banner/" +
                            (_vm.$vuetify.theme.dark
                              ? item.pozadie_obrazok_mobil_tmavy
                              : item.pozadie_obrazok_mobil_svetly)
                      }
                    })
              ],
              !_vm.isMobile && !item.ext
                ? _c("div", { staticClass: "banner-content" }, [
                    _c(
                      "div",
                      { staticClass: "d-flex" },
                      [
                        _c("text-group", {
                          attrs: {
                            invert: "",
                            xl: "",
                            btext: item.text_vlavo_titulok,
                            gap: 8,
                            utext: item.text_vlavo
                          }
                        }),
                        _c(
                          "div",
                          { staticClass: "mr-auto mt-3px" },
                          [
                            item.text_vlavo_info.length > 0
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { slot: "append", bottom: "" },
                                    slot: "append",
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function(ref) {
                                            var on = ref.on
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  {
                                                    attrs: {
                                                      slot: "activator"
                                                    },
                                                    slot: "activator"
                                                  },
                                                  on
                                                ),
                                                [_vm._v("mdi-help-circle")]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        " " + _vm._s(item.text_vlavo_info) + " "
                                      )
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _c("text-group", {
                          staticClass: "mt-5px",
                          attrs: {
                            large: "",
                            gap: 4,
                            smallHeader: "",
                            btext: item.text_vpravo,
                            utext: ""
                          }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ],
            2
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }